import {Skeleton} from '@/shared/ui/components/skeleton';

export const ScheduleSkeleton = () => (
  <div
    className="mx-auto flex w-full max-w-4xl flex-col gap-6 px-4 pt-6 pb-8 sm:px-6 sm:pt-8"
    aria-busy="true"
  >
    <Skeleton className="h-8 w-40" />
    <Skeleton className="h-9 w-56" />
    <Skeleton className="h-40 w-full" />
    <Skeleton className="h-40 w-full" />
  </div>
);
